import { FunctionComponent } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { oneLine } from 'common-tags';

import { CaretDown, ChevronDown } from '@/icons';

import { TypeAccordionSideMenuProps } from './types';

export const AccordionSideMenu: FunctionComponent<
  TypeAccordionSideMenuProps
> = ({
  className,
  title,
  children,
  variant,
  font = 'large',
}: TypeAccordionSideMenuProps) => {
    const Icon = variant !== 'link' ? ChevronDown : CaretDown;

    return (
      <Disclosure
        as="div"
        className={oneLine`
        text-body
        ${font === 'small' ? 'text-body--s' : ''}
        ${font === 'medium' ? 'text-body--m' : ''}
        ${font === 'large' ? 'text-body--l' : ''}
        ${className}
      `}
      >
        {({ open }) => (
          <>
            <DisclosureButton
              className={oneLine`
              flex text-left w-full py-6 items-center font-semibold ${open ? 'border-b border-secondary-200' : ''
                }
              ${variant === 'link'
                  ? 'text-primary-500 tracking-widest uppercase'
                  : 'justify-between'
                }
            `}
            >
              {title}

              <Icon
                className={`text-primary-500 ${open ? 'rotate-180' : ''}`}
                width={32}
                height={28}
              />
            </DisclosureButton>

            <DisclosurePanel
              unmount={false}
              className={`${!open ? 'py-6' : ''}`}
            >
              {children}
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
    );
  };

AccordionSideMenu.displayName = 'Accordion';
